import { DownloadCategory, ReportStatus } from '@/graphql/types';

export const DownloadStatusTranslations = {
    [ReportStatus.Ready]: gettext('READY'),
    [ReportStatus.InProgress]: gettext('IN_PROGRESS'),
    [ReportStatus.Failed]: gettext('FAILED'),
    [ReportStatus.Downloaded]: gettext('DOWNLOADED'),
} as const satisfies Record<ReportStatus, string>;

export const DownloadCategoryTranslations = {
    [DownloadCategory.Report]: gettext('REPORT'),
    [DownloadCategory.DataExport]: gettext('DATA_EXPORT'),
} as const satisfies Record<DownloadCategory, string>;
